import ms from 'ms'

const subscribedToAddressNotificationsMap = new Map()

const UPDATE_LOOP_INTERVAL = ms('5m')

export function subscribeToWSNotifications({
  addressesByWalletAccount,
  tick,
  server,
  beforeStart = false,
}) {
  Object.entries(addressesByWalletAccount).forEach(([walletAccount, addresses]) => {
    const address = String([...addresses][0]).toLowerCase() // Only check m/0/0
    const mapKey = `${server.getURL()}:${address}` // different chains might have the same addresses
    if (subscribedToAddressNotificationsMap.has(mapKey)) return

    server.ws.watch(address)
    server.ws.events.on(`address-${address}`, () => {
      tick({ refresh: false, walletAccount })
    })
    subscribedToAddressNotificationsMap.set(mapKey, true)
    if (!beforeStart) {
      // tick for a new wallet account
      tick({ refresh: false, walletAccount })
    }
  })
}

export function subscribeToGasPriceNotifications({
  server,
  updateGasPrice,
  subscribedToGasPriceMap,
}) {
  const mapKey = server.getURL()
  if (subscribedToGasPriceMap.has(mapKey)) return
  server.ws.events.on('gasprice', updateGasPrice)
  subscribedToGasPriceMap.set(mapKey, true)
}

export function enableWSUpdates({
  interval,
  server,
  timer,
  tickWalletAccounts,
  tick,
  addressesByWalletAccount,
  beforeStart = false,
}) {
  const defaultInterval = interval

  subscribeToWSNotifications({
    server,
    beforeStart,
    tick,
    addressesByWalletAccount,
  })

  server.ws.events.on('open', () => {
    if (timer.isRunning) {
      timer.setNewInterval(UPDATE_LOOP_INTERVAL)
    }
  })
  server.ws.events.on('close', async () => {
    if (timer.isRunning) {
      await timer.setNewInterval(defaultInterval)
      return tickWalletAccounts()
    }
  })
  server.ws.open()
}
